<template>
  <div class="contents-inner">
    <div class="col-type-01">
      <div
        v-for="(title,i) in titles"
        :key="i"
        class="-block w49"
      >
        <job-preview-button
          class="-middle"
          :title="title"
        />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@use "@/styles/preview/sp/common/base" as *;
</style>

<script>
import jobPreviewCommon from '@/lib/jobPreviewCommon'
import JobPreviewButton from '@/components/atoms/JobPreviewButton'

export default {
  components: {
    JobPreviewButton
  },
  mixins: [jobPreviewCommon],
  props: {
    titles: {
      type: Array,
      required: true
    }
  }
}
</script>
